// extracted by mini-css-extract-plugin
module.exports = {"title":"_41aee","row":"_82ad2","content":"_9296d"};